import featureService from '@services/feature.service';
import { coreTranslations, externalLinksTranslations } from 'translations';
import isMobileAppView from 'common/utility/isMobileAppView';

export const tilesConfig = [
    {
        id: 'custom-verbiage',
        title: coreTranslations.ng_core_customVerb,
        description: coreTranslations.ng_core_customVerbiageDescription,
        path: {
            redirectTo: '/prepareCustomVerbiage.do',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access =>
            access.canViewCustomVerbiage() && featureService.getFeature('mir3Redirects') && !isMobileAppView()
    },
    {
        id: 'external-links',
        title: externalLinksTranslations.ng_extLinks_externalLinks,
        description: externalLinksTranslations.ng_extLinks_externalLinksDescription,
        path: '/external-links',
        visible: access =>
            access.canManageExternalLinks() && access.canViewExternalLinks() && access.canManageAssetDataStore()
    }
];
